<template>
    <q-dialog v-model="showModal" @hide="reset()">
        <q-card style="max-width: 425px; min-width: 225px;" class="full-width">
            <q-card-section>
                <div class="text-h6 row items-center">
                    <q-btn icon="mdi-close" flat round dense v-close-popup />
                    <q-space />
                    <div class="text-h6 text-bold q-mb-sm">Join Our Email List<i class="mdi mdi-email q-mx-sm" /></div>
                </div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <div v-if="subscribed" class="row q-mt-xs">
                    <div class="row q-mb-lg">
                        <div class="col-auto">
                            <q-icon name="mdi-check-circle" size="xl" color="positive" class="on-left" />
                        </div>
                        <div class="col">
                            {{ subscribeText }}
                        </div>
                    </div>

                    <div class="row q-col-gutter-sm">
                        <div class="col-xs-12 col-sm-auto">
                            <q-btn label="Ok" type="reset" color="primary" class="full-width" v-close-popup />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p>Join our mailing list for product and update notifications, and for other Avenir news. Just enter your information below and click Subscribe.</p>
                    <q-form @submit="onSubmit"
                            autocomplete="off"
                            class="q-gutter-y-md column">
                        <div class="q-mt-xs row q-col-gutter-md">
                            <div class="col-xs-12 col-sm-6">
                                <q-input v-model.trim="firstName"
                                         label="First Name"
                                         autocomplete="on" name="firstName"
                                         :rules="[ val => $v.firstName.required || 'First name is required' ]"
                                         outlined dense
                                         hide-bottom-space>
                                    <template v-slot:prepend>
                                        <q-icon name="mdi-account" />
                                    </template>
                                </q-input>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <q-input v-model.trim="lastName"
                                         label="Last Name"
                                         autocomplete="on" name="lastName"
                                         :rules="[ val => $v.lastName.required || 'Last name is required' ]"
                                         outlined dense
                                         hide-bottom-space>
                                </q-input>
                            </div>
                        </div>
                        <q-input v-model.trim="email"
                                 @input="error=false"
                                 label="Email"
                                 autocomplete="on" name="email"
                                 :rules="[ val => $v.email.required || 'Email is required', val => $v.email.email || 'Not a valid email format' ]"
                                 outlined dense
                                 hide-bottom-space>
                            <template v-slot:prepend>
                                <q-icon name="mdi-email" />
                            </template>
                        </q-input>
                        <div v-if="error" class="row text-caption q-mt-xs text-negative">{{ subscribeText }}</div>

                        <div class="row q-col-gutter-sm" style="display: flex; justify-content: space-between; align-items: center;">
                            <div style="display: flex;" class="col-xs-12 col-sm-auto">
                                <div class="col-xs-12 col-sm-auto">
                                    <q-btn color="primary" label="Subscribe" :disable="loading || subscribed || !email" type="submit" class="full-width" />
                                </div>
                                <div class="col-xs-12 col-sm-auto q-pl-sm">
                                    <q-btn label="Cancel" type="reset" color="primary" flat class="full-width" v-close-popup />
                                </div>
                            </div>
                            <div class="col-auto text-right">
                                <router-link to="/privacy">Privacy Policy</router-link>
                            </div>
                        </div>

                    </q-form>
                </div>
            </q-card-section>

            <q-inner-loading :showing="loading">
                <div>
                    <q-spinner color="primary"
                               :thickness="2"
                               size="3em" />
                </div>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>
<script>
    import { mapState } from 'vuex'
    import { email, required } from 'vuelidate/lib/validators'

    export default {
        name: 'dialog-subscribe',
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                email: '',
                firstName: '',
                lastName: '',
                subscribed: false,
                subscribeText: '',
                error: false,
                loading: false,
            }
        },
        validations: {
            email: { email, required },
            firstName: { required },
            lastName: { required }
        },
        methods: {
            reset() {
                this.firstName = ''
                this.lastName = ''
                this.email = ''
                this.subscribeText = ''
                this.subscribed = false
            },
            onSubmit() {
                this.$v.$touch()
                if (this.$v.$pending || this.$v.$error) return

                this.postBenchmarkEmail()

            },
            postBenchmarkEmail() {

                var vm = this
                vm.loading = true

                const payload = {
                    email: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName
                }

                this.$store.dispatch('submitNewsContactToBenchmark', payload).then(() => {
                    vm.loading = false
                    if (this.submitNewsContactToBenchmarkData == "True") {
                        //Needs to OptIn
                        vm.subscribeText = 'Thanks for subscribing! Check your email and click the link to confirm your subscription.'
                        vm.subscribed = true
                    } else if (this.submitNewsContactToBenchmarkData == "False") {
                        //Email is already subscribed
                        vm.subscribeText = 'Email already used, please check your inbox to confirm your subscription.'
                        vm.error = true
                    }
                    else {
                        //An Error Ocurred
                        vm.subscribeText = 'Something went wrong, please try again later.'
                        vm.error = true
                    }
                })

            },
        },
        computed: {
            ...mapState([
                'submitNewsContactToBenchmarkData',
                'submitNewsContactToBenchmarkPending',
            ]),
            showModal: {
                get() {
                    return this.show
                },
                set(value) {
                    this.$emit('update:show', value)
                }
            },
        },
        created() {
            this.reset()
        },

    }
</script>
